import React, { useContext, useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { SPAViewContext } from '@confluence/spa-view-context/entry-points/SPAViewContext.ts';
import { AIUpsell } from '@confluence/change-edition/entry-points/AIUpsell.ts';

import quickSummaryUpsellBannerLight from './assets/quickSummaryUpsellBannerLight.svg';
import quickSummaryUpsellBannerDark from './assets/quickSummaryUpsellBannerDark.svg';

const i18n = defineMessages({
	headerText: {
		id: 'quick-summary.upsell.header.text',
		defaultMessage: 'Improve productivity with Rovo',
		description: 'Header text for Quick Summary Upsell Dialog',
	},
	headerTextAdmin: {
		id: 'quick-summary.upsell.header.text.admin',
		defaultMessage: 'Improve team productivity with Rovo',
		description: 'Header text for Quick Summary Upsell Dialog for admins',
	},
	learnMoreLinkTextUser: {
		id: 'quick-summary.upsell.learn-more.link.text.user',
		defaultMessage: 'Learn more about Rovo',
		description: 'Learn more link text for AI Upsell Dialog',
	},
	bodyTextAdmin: {
		id: 'quick-summary.upsell.body.text.admin',
		defaultMessage:
			'Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Upgrade to Premium',
		description: 'Body text for Quick Summary Upsell Dialog for admins',
	},
	bodyTextUser: {
		id: 'quick-summary.upsell.body.text.user',
		defaultMessage:
			'Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Try Rovo today',
		description: 'Body text for Quick Summary Upsell Dialog for non-admin users',
	},
});

export const ROVO_DOCS_LINK_END_USER =
	'https://www.atlassian.com/software/rovo/guides/end-user-guide/introduction';

export const ROVO_DOCS_LINK_ADMIN =
	'https://www.atlassian.com/software/rovo/guides/admin-guide/introduction';

export const QuickSummaryUpsell = () => {
	const intl = useIntl();
	const { isSiteAdmin } = useContext(SPAViewContext);

	const headerText = isSiteAdmin
		? intl.formatMessage(i18n.headerTextAdmin)
		: intl.formatMessage(i18n.headerText);

	const bodyText = isSiteAdmin
		? intl.formatMessage(i18n.bodyTextAdmin)
		: intl.formatMessage(i18n.bodyTextUser);

	const learnMoreLink = isSiteAdmin ? ROVO_DOCS_LINK_ADMIN : ROVO_DOCS_LINK_END_USER;

	const learnMoreText = intl.formatMessage(i18n.learnMoreLinkTextUser);

	const learnMoreLinkProps = useMemo(
		() => ({
			href: learnMoreLink,
			message: learnMoreText,
		}),
		[learnMoreLink, learnMoreText],
	);

	const imageProps = useMemo(
		() => ({
			src: {
				default: quickSummaryUpsellBannerLight,
				dark: quickSummaryUpsellBannerDark,
			},
			alt: '',
		}),
		[],
	);

	return (
		<AIUpsell
			title={headerText}
			body={bodyText}
			feature="quickSummary"
			learnMoreLink={learnMoreLinkProps}
			image={imageProps}
		/>
	);
};
